import { Route } from '@angular/router';
import { WelcomeComponent } from '@pool-league/frontend-web-feature-welcome';
import { isNotLoggedIn } from '@pool-league/frontend-shared-util-auth';
import { provideState } from '@ngrx/store';
import {
  PlayersEffects,
  playersFeature,
} from '@pool-league/frontend-web-data-players';
import { NotFoundComponent } from '@pool-league/frontend-shared-ui-not-found';
import { provideEffects } from '@ngrx/effects';
import {
  SeasonEffects,
  seasonFeature,
} from '@pool-league/frontend-web-data-season';

export const appRoutes: Route[] = [
  {
    path: 'killer',
    loadChildren: () => import('@pool-league/frontend-web-feature-killer'),
  },
  {
    path: '**',
    component: WelcomeComponent,
    canMatch: [isNotLoggedIn],
  },
  {
    path: '',
    loadComponent: () => import('@pool-league/frontend-web-feature-chrome'),
    providers: [
      provideState(playersFeature),
      provideEffects([PlayersEffects]),
      provideState(seasonFeature),
      provideEffects(SeasonEffects),
    ],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('@pool-league/frontend-web-feature-home'),
      },
      {
        path: 'seasons',
        pathMatch: 'full',
        loadComponent: () =>
          import('@pool-league/frontend-web-feature-season-list'),
      },
      {
        path: 'seasons/:seasonSlug',
        loadChildren: () =>
          import('@pool-league/frontend-web-feature-season-info'),
      },
      {
        path: 'players',
        pathMatch: 'full',
        loadComponent: () =>
          import('@pool-league/frontend-web-feature-player-list'),
      },
      {
        path: 'players/:playerSlug',
        pathMatch: 'full',
        loadComponent: () =>
          import('@pool-league/frontend-web-feature-player-info'),
      },
      {
        path: 'rules',
        pathMatch: 'full',
        loadComponent: () =>
          import('@pool-league/frontend-shared-feature-rules'),
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];
